export default __webpack_public_path__ + "static/media/GithubMockUp.5cec1b30.jpg";